import React from 'react'
import { useDeleteApiKeyMutation } from '../api/ApiCredentials'
import XCircleFillIcon from '../../../assets/icons/XCircleFill';
import Toast from '../../../components/ToastNotification';

const DeleteCredential = ({ onClose, selectedRow, paginationState }) => {
    const { id, api_key } = selectedRow;

    const [deleteApi] = useDeleteApiKeyMutation();

    const handleDelete = async () => {
      try {
        await deleteApi({ id }).unwrap();
        paginationState.setPagination({
            ...paginationState.pagination,
            pageIndex: 0
        })
        Toast.success('Api Key deleted successfully');
      } catch (error) {
        Toast.error(error.data.message)
      }
    }
    
    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" style={{width: '450px'}}>
                <div>
                    <h3 className='heading'>Delete API Key</h3>
                    <button className='close-btn' onClick={onClose}><XCircleFillIcon size={24} /></button>
                </div>
                <div className="content_body">
                    <p>Are you sure you want to Delete <strong>{api_key}</strong> API Key?</p>
                    <div className='layout_footer'>
                        <button onClick={handleDelete} className='save-btn'>Delete</button>
                        <button onClick={onClose} className='cancel-btn'>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeleteCredential
